module.exports = __webpack_public_path__ + "img/women.a2c95241.png";